/* eslint-disable max-len */
const text = {
	CONTACT_US: {
		PAGE_GREETING: 'Hi, apa yang bisa kami bantu?',
		PAGE_GREETING_DESC:
			'Kami sangat senang menerima pertanyaan atau saran. Jangan ragu untuk mengisi formulir di bawah ini, kami akan segera menghubungimu kembali',
	},
	ALPHABET: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
};

export default text;
